<template>
    <div></div>
</template>

<script>
    import {bus} from "../../../main";

    export default {
        name: "autoLoader",
        props: {
            tourResultList: {
                type: Array,
                default: () => []
            },
            listType: {
                type: String,
                required: true
            },
            collapseByHotel: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                localPage: 1,
                externalPage: 1,
                localCount: 0,
                externalCount: 0,
                localCountMax: 0,
                externalCountMax: 0,
            }
        },
        resultCount: 20,
        computed: {
            items() {
                if (!this.tourResultList.length) return [];

                if (this.listType === "big-row") {
                    return document.querySelectorAll(".big-row-tour-result-list .card-wrap")
                } else if (this.listType === "row") {
                    return document.querySelectorAll(".row-tour-result-list .card-wrap")
                } else if (this.listType === "grid") {
                    return document.querySelectorAll(".grid-tour-result-list .card-wrap")
                } else {
                    return document.querySelectorAll(".grid-tour-result-list.map-mode .card-wrap")
                }
            },
        },
        created() {
            bus.$on("searched-for-hotels", () => {
                this.localPage = 1;
                this.externalPage = 1;
                this.localCount = 0;
                this.externalCount = 0;
                this.localCountMax = 0;
                this.externalCountMax = 0;
            });

            window.addEventListener("scroll", this.windowScroll);
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.windowScroll);
        },
        methods: {
            windowScroll() {
                const rowGap = 15;
                const clientHeight = window.innerHeight;

                let itemsCount = 0;
                for (let i = 0; i < this.items.length; i++) {
                    const itemTop = this.items[i].getBoundingClientRect().top + rowGap;

                    if (itemTop >= clientHeight) {
                        itemsCount = i;
                        break
                    }
                    if (i === this.items.length-1) {
                        itemsCount = i + 1;
                    }
                }

                this.localCount = 0;
                this.externalCount = 0;
                this.tourResultList.forEach((x, i) => {
                    if (i + 1 > itemsCount) return;

                    x.IsRemoteHotels ? this.externalCount++ : this.localCount++;
                });

                if (this.localCount % this.$options.resultCount === 0 && this.localCount > this.localCountMax) {
                    this.localCountMax += this.$options.resultCount;
                    this.localPage++;
                    this.$emit("loadLocal", this.localPage);
                }
                if (this.externalCount % this.$options.resultCount === 0 && this.externalCount > this.externalCountMax) {
                    this.externalCountMax += this.$options.resultCount;
                    this.externalPage++;
                    this.$emit("loadExternal", this.externalPage);
                }
            }
        },
        watch: {
          collapseByHotel() {
            this.localCountMax = 0;
            this.externalCountMax = 0;
            this.localPage = 1;
            this.externalPage = 1;
          }
        }
    }
</script>